import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AdminLayoutComponent } from './admin-layout.component';
import { ComponentsModule } from './components/components.module';
import { WelcomeComponent } from '../../components/yoklama/welcome/welcome.component';





@NgModule({
  declarations: [
    AdminLayoutComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,



  ]
  , exports: [
    AdminLayoutComponent

  ]


})

export class AdminLayoutModule { }
